import { render, staticRenderFns } from "./DependingCentersComponent.vue?vue&type=template&id=0f68ce07&lang=pug&"
import script from "./DependingCentersComponent.vue?vue&type=script&lang=js&"
export * from "./DependingCentersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports